import { Card, CardBody } from "reactstrap"
import BikroyIcon from "components/Common/BikroyIcon"
import TiktokIcon from "components/Common/TiktokIcon"

const VehicleContentSidebar = ({ data, params, updateParams }) => {

  return (
    <Card className="filemanager-sidebar me-md-2">
      <CardBody>
        <div className="d-flex flex-column h-100">
          <div className="mb-4">
            <ul className="list-unstyled categories-list mb-0">
              {data?.length ? (
                data?.map((item, index) => {
                  const isActive = params?.slug === item?.slug
                  const IconComponent =
                    item.slug === "tiktok"
                      ? TiktokIcon
                      : item.slug === "bikroy"
                      ? BikroyIcon
                      : null

                  return (
                    <li
                      key={index}
                      className={isActive ? "bg-light rounded" : ""}
                    >
                      <button
                        type="button"
                        onClick={() =>
                          updateParams(prev => ({
                            ...prev,
                            slug: item.slug,
                            page: 1,
                          }))
                        }
                        className="text-body d-flex align-items-center py-2 px-2 rounded w-100 border-0 bg-transparent"
                      >
                        <span className="me-2 d-flex align-items-center">
                          {IconComponent ? (
                            <IconComponent width={18} height={18} />
                          ) : (
                            <i
                              className={`font-size-16 me-2 ${item.icon || ""}`}
                            ></i>
                          )}
                        </span>
                        <span className="me-auto fw-medium">
                          {item.platform_name}
                        </span>
                        {item.total_pending !== undefined && (
                          <span className="badge bg-success rounded-pill ms-2">
                            {item.total_pending}
                          </span>
                        )}
                        {item.icons && (
                          <i className="mdi mdi-circle-medium text-danger ms-2"></i>
                        )}
                      </button>
                    </li>
                  )
                })
              ) : (
                <li>
                  No vehicle content available. Please add a new one to get
                  started.
                </li>
              )}
            </ul>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

export default VehicleContentSidebar
